<script setup>
import { Line , Scatter } from 'vue-chartjs'
import Duration from '@common/Duration'

const { DateTime } = require('luxon')
import { onMounted, reactive } from 'vue'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale
)

const data = reactive([])

const chartData = reactive({
  labels: [],
  datasets: [
    {
      label: 'Verlies',
      backgroundColor: 'rgba(255,99,132,0.2)',
      borderColor: 'rgba(255,99,132,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [],
    },
    {
      label: 'Omzet',
      backgroundColor: 'rgba(5,166,166,0.2)',
      borderColor: 'rgba(5,166,166,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(5,166,166,0.4)',
      hoverBorderColor: 'rgba(5,166,166,1)',
      data: [],
    },
    {
      label: 'Personeelskosten',
      backgroundColor: 'rgba(2, 145, 255, 0.2)',
      borderColor: 'rgba(2, 145, 255, 1.00)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(2, 145, 255, 0.4)',
      hoverBorderColor: 'rgba(2, 145, 255, 1.00)',
      data: [],
    },
    {
      label: 'Upsell Profit',
      backgroundColor: 'rgba(20, 7, 217, 0.2)',
      borderColor: 'rgba(20, 7, 217, 1.00)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(20, 7, 217, 0.4)',
      hoverBorderColor: 'rgba(20, 7, 217, 1.00)',
      data: [],
    },
  ],
})

const fetchDataForDuration = (duration) => {
  chartData.datasets.forEach((dataset)=>dataset.data = []);
  chartData.labels = [];
  axios
    .get(
      route('api.graphs.fetch', {
        duration: duration,
      })
    )
    .then((response) => {
      processData(response.data ,duration);
    })
    .catch((error) => {
      console.error(error)
    })
}

const processData = (responseData , duration) => {
  let timeInterval = 0;
  switch(duration) {
    case 'LAST_YEAR':
      timeInterval = 365;
      break;
    case 'LAST_90_DAYS':
      timeInterval = 91;
      break;
    default:
      timeInterval = 31;
  }


  let today = new Date();
  let sets = [1,2,3,4];
  let dataSets = sets.map((set)=>responseData.filter((data)=>data.label === set));

// creating labels
  for(let i=0 ; i< timeInterval ; i++){
    let day = new Date();
    day.setDate(today.getDate()-i);
    chartData.labels.unshift(day.toLocaleDateString());
  }

// fill out the datasets
  dataSets.forEach((dataSet , index )=>{
    //console.log('length' + dataSet.length )
    if(dataSet.length){
      chartData.datasets[index].data = chartData.labels.map(( date ) => {
        return {
          x : date,
          y : findValue(date , dataSet)
        }
      })
    }
  })
}

/*const findValue = function ( date , dataSet ) {
  let index = dataSet.findIndex((el)=> date === formattedDate(el.date))
  return (index >-1)? dataSet[index].value : 0;
}*/
const findValue = function ( date , dataSet ) {
  let data = dataSet.filter((el)=> date === formattedDate(el.date));
  //console.log(data);
  if (data.length){
    let total = 0
    let value = data.reduce((total, item) => total + parseFloat(item.value),0)
    //console.log('sum' + value)
    return  value;
  }
 return 0

}

const formattedDate = function (date){
  return DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
}
</script>

<template>
  <div class="mt-4 space-y-4">
    <div class="text-xl">Verkoops resultaten</div>
    <Duration @update-selected="fetchDataForDuration" />
    <div class="hidden lg:block">
      <Line :chart-data="chartData" :height="100" class="mt-4"></Line>
    </div>
    <div class="lg:hidden">
      <Line :chart-data="chartData" :height="400" class="mt-4"></Line>
    </div>

  </div>
</template>
